/**
 * Get the internal API URL for server-side requests.
 *
 * In production (Docker): INTERNAL_API_URL is set by entrypoint.sh
 * In development: Falls back to localhost:12081 (Go backend port)
 */
export function getInternalApiUrl(): string {
  return process.env.INTERNAL_API_URL || "http://localhost:12081";
}
